import { Link, useParams } from "react-router-dom";
import { useCartStore } from "../store";

export function OrderConfirmation() {
	const { id } = useParams<{ id: string }>();
	const getOrder = useCartStore((s) => s.getOrder);
	const order = id ? getOrder(id) : undefined;

	if (!order) {
		return (
			<section className="py-16 text-center">
				<h1 className="text-2xl font-semibold text-slate-900">
					Order not found
				</h1>
				<p className="mt-2 text-slate-600">
					We couldn't find that order.
				</p>
				<Link
					to="/products"
					className="btn-secondary mt-6 inline-block"
					data-testid="order-back"
				>
					Back to products
				</Link>
			</section>
		);
	}

	return (
		<section
			data-testid="order-confirmation"
			className="max-w-2xl mx-auto"
		>
			<div className="rounded-lg border border-emerald-200 bg-emerald-50 p-6">
				<h1 className="text-3xl font-bold text-emerald-900">
					Thanks for your order!
				</h1>
				<p className="mt-2 text-emerald-800">
					Order ID:{" "}
					<span className="font-mono" data-testid="order-id">
						{order.id}
					</span>
				</p>
			</div>

			<div className="mt-8">
				<h2 className="text-lg font-semibold text-slate-900">
					Order summary
				</h2>
				<ul className="mt-4 divide-y divide-slate-200 border border-slate-200 rounded-lg bg-white">
					{order.lines.map((line) => (
						<li
							key={line.productId}
							className="flex items-center justify-between p-4"
						>
							<div>
								<p className="font-medium text-slate-900">
									{line.name}
								</p>
								<p className="text-sm text-slate-600">
									${line.price} x {line.quantity}
								</p>
							</div>
							<span className="font-medium text-slate-900">
								${line.price * line.quantity}
							</span>
						</li>
					))}
				</ul>
				<div className="mt-4 flex items-center justify-between">
					<span className="text-slate-700">Subtotal</span>
					<span className="text-xl font-semibold text-slate-900">
						${order.subtotal}
					</span>
				</div>
			</div>

			<div className="mt-8">
				<h2 className="text-lg font-semibold text-slate-900">
					Shipping to
				</h2>
				<address className="mt-2 not-italic text-slate-700 leading-relaxed">
					<div>{order.shipping.name}</div>
					<div>{order.shipping.addressLine1}</div>
					<div>
						{order.shipping.city}, {order.shipping.postalCode}
					</div>
					<div>{order.shipping.country}</div>
				</address>
			</div>

			<div className="mt-8">
				<Link
					to="/products"
					data-testid="order-continue"
					className="btn-primary inline-block"
				>
					Continue shopping
				</Link>
			</div>
		</section>
	);
}

export default OrderConfirmation;
